export default "__VITE_ASSET__bdfcee78__"